<template>
  <l-section bg-color="bg-secondary" class="error">
    <l-container>
      <a-header :displayFont="true" classes="h2">Page not found</a-header>
      <div class="error__text">
        <p>Looks like you've followed a broken link or entered a URL that doesn't exist on this site.</p>
        <h-slug :to="{ url: '/' }" class="link-u-reverse">
          <button>Go to the frontpage</button>
        </h-slug>
      </div>
    </l-container>
  </l-section>
</template>

<script setup>
defineProps({
  blok: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<style lang="scss" scoped>
.error {
  width: 100%;
  min-height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-wrap: wrap;
  padding: 5rem 0 3rem;
  &__header {
    position: relative;
    display: flex;
    gap: 3vw;
    flex-wrap: wrap;
  }
  &__text {
    margin-top: 1rem;
    max-width: 35rem;
    margin-left: auto;
    margin-right: auto;
    color: var(--color-txt-primary);
    a {
      display: inline-block;
      margin-top: 1rem;
    }
  }
}
</style>
